export default __webpack_public_path__ + "static/media/yellow_desktop.dfb95c0b.png";